"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectableOverflow = void 0;
var React = __importStar(require("react"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var defaultTag = 'div';
var defaultStyle = {
    width: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};
var DetectableOverflow = /** @class */ (function (_super) {
    __extends(DetectableOverflow, _super);
    function DetectableOverflow(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = React.createRef();
        _this.state = { overflow: false };
        _this.updateState = _this.updateState.bind(_this);
        return _this;
    }
    DetectableOverflow.prototype.componentDidMount = function () {
        this.updateState();
    };
    DetectableOverflow.prototype.componentDidUpdate = function () {
        this.updateState();
    };
    DetectableOverflow.prototype.updateState = function () {
        if (this.ref.current === null) {
            return;
        }
        var _a = this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c;
        var newState = (handleWidth && this.ref.current.offsetWidth < this.ref.current.scrollWidth) ||
            (handleHeight && this.ref.current.offsetHeight < this.ref.current.scrollHeight);
        if (newState === this.state.overflow) {
            return;
        }
        this.setState({ overflow: newState });
        if (this.props.onChange) {
            this.props.onChange(newState);
        }
    };
    DetectableOverflow.prototype.render = function () {
        var tag = this.props.tag ? this.props.tag : defaultTag;
        var style = this.props.style ? this.props.style : defaultStyle;
        var className = this.props.className ? this.props.className : '';
        return (React.createElement(react_resize_detector_1.default, { handleWidth: true, onResize: this.updateState, targetRef: this.ref }, React.createElement(tag, {
            style: style,
            className: className,
            ref: this.ref,
        }, this.props.children)));
    };
    return DetectableOverflow;
}(React.Component));
exports.DetectableOverflow = DetectableOverflow;
//# sourceMappingURL=DetectableOverflow.js.map